import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import 'core-js/stable';
import './scss/index.min.css';

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

import { StaticDataProvider } from './config';

import MainRouter from './router';
import ScrollRestoration from './router/scrollRestoration';

import { isIE } from './helper';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-147447473-3');
if (isIE()) {
  document.body.classList.add('is-ie');
}

ReactDOM.render(
  <BrowserRouter>
    <StaticDataProvider>
      <ScrollRestoration>
        <MainRouter />
      </ScrollRestoration>
    </StaticDataProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// const isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
// if (isSafari) serviceWorker.unregister();
// else serviceWorker.register();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
